import * as React from "react";
import type { SVGProps } from "react";
const SvgKommer = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 71" {...props}>
    <path
      d="M2230 295v42.56a5.443 5.443 0 0 1-5.44 5.44h-57.12a5.443 5.443 0 0 1-5.44-5.44V289h11v1a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-1h22v1a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-1h11zm-34.64 15.212c0-4.359-3.8-7.11-9.8-7.11-6.24 0-10.38 3.412-10.39 8.575h6.71a3.063 3.063 0 0 1 3.36-3.055c2.04 0 3.26 1 3.26 2.626 0 1.643-1.22 2.662-3.17 2.662h-3.09v5.073h3.06c2.11 0 3.35 1 3.35 2.679 0 1.662-1.31 2.769-3.28 2.769-2.18 0-3.52-1.054-3.57-2.769h-7.11c.25 5.252 4.36 8.646 10.52 8.646 6.73 0 11.02-3.054 11.02-7.878 0-3.519-2.44-5.752-6.17-6.162v-.143a6.02 6.02 0 0 0 5.3-5.913m17.41-6.395h-7.46l-6.37 4.323v6.341l6.23-4.18h.14v19.293h7.46zM2219 275h5.56a5.443 5.443 0 0 1 5.44 5.44V286h-11zm-6 17a4 4 0 0 1-4-4v-12a4 4 0 0 1 8 0v12a4 4 0 0 1-4 4m-28-17h22v11h-22zm-6 17a4 4 0 0 1-4-4v-12a4 4 0 0 1 8 0v12a4 4 0 0 1-4 4m-17-11.56a5.443 5.443 0 0 1 5.44-5.44h5.56v11h-11z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-2162 -272)"
    />
  </svg>
);
export default SvgKommer;
